// extracted by mini-css-extract-plugin
export var btn = "QuickLinks-module--btn--f35eb";
export var btnAlt = "QuickLinks-module--btnAlt--18803";
export var btnContainer = "QuickLinks-module--btnContainer--81121";
export var btnIcon = "QuickLinks-module--btnIcon--cf152";